// action types
import { createRequestTypes } from "../../utils";

// Recipe CRUD
export const CREATE_RECIPE = createRequestTypes("CREATE_RECIPE");
export const UPDATE_RECIPE = createRequestTypes("UPDATE_RECIPE");
export const DELETE_RECIPE = createRequestTypes("DELETE_RECIPE");
export const GET_RECIPES_BY_ORG = createRequestTypes("GET_RECIPES_BY_ORG");
export const GET_MY_RECIPES = createRequestTypes("GET_MY_RECIPES");
export const GET_PUBLIC_RECIPES = createRequestTypes("GET_PUBLIC_RECIPES");
export const DUPLICATE_RECIPE = createRequestTypes("DUPLICATE_RECIPE");
export const PUBLISH_RECIPE = createRequestTypes("PUBLISH_RECIPE");
export const LIKE_RECIPE = createRequestTypes("LIKE_RECIPE");
export const SHARE_RECIPE = createRequestTypes("SHARE_RECIPE");
export const SEARCH_PUBLIC_RECIPES = createRequestTypes("SEARCH_PUBLIC_RECIPES");

// UI state
export const SET_SELECTED_RECIPE = 'SET_SELECTED_RECIPE';
export const SET_RECIPE_VIEW = 'SET_RECIPE_VIEW';
export const RESET_RECIPES_STATE = 'RESET_RECIPES_STATE';
export const SET_RECIPE_FILTERS = 'SET_RECIPE_FILTERS';
export const CLEAR_RECIPE_MESSAGES = 'CLEAR_RECIPE_MESSAGES';

// ----------------------------------------------------------------------
// Action Creators - Recipe CRUD
// ----------------------------------------------------------------------

export const createRecipeRequest = (data) => ({
  type: CREATE_RECIPE.REQUEST,
  payload: data,
});

export const createRecipeSuccess = (data) => ({
  type: CREATE_RECIPE.SUCCESS,
  payload: { data },
});

export const createRecipeFailure = (error) => ({
  type: CREATE_RECIPE.FAILURE,
  payload: error,
});

export const updateRecipeRequest = (id, data) => ({
  type: UPDATE_RECIPE.REQUEST,
  payload: { id, data },
});

export const updateRecipeSuccess = (data) => ({
  type: UPDATE_RECIPE.SUCCESS,
  payload: { data },
});

export const updateRecipeFailure = (error) => ({
  type: UPDATE_RECIPE.FAILURE,
  payload: error,
});

export const deleteRecipeRequest = (id) => ({
  type: DELETE_RECIPE.REQUEST,
  payload: id,
});

export const deleteRecipeSuccess = (id) => ({
  type: DELETE_RECIPE.SUCCESS,
  payload: { id },
});

export const deleteRecipeFailure = (error) => ({
  type: DELETE_RECIPE.FAILURE,
  payload: error,
});

export const getRecipesByOrgRequest = (organizationId) => ({
  type: GET_RECIPES_BY_ORG.REQUEST,
  payload: organizationId,
});

export const getRecipesByOrgSuccess = (data) => ({
  type: GET_RECIPES_BY_ORG.SUCCESS,
  payload: { data },
});

export const getRecipesByOrgFailure = (error) => ({
  type: GET_RECIPES_BY_ORG.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// UI State Actions
// ----------------------------------------------------------------------

export const setSelectedRecipe = (recipe) => ({
  type: SET_SELECTED_RECIPE,
  payload: recipe,
});

export const getMyRecipesRequest = () => ({
  type: GET_MY_RECIPES.REQUEST,
});

export const getMyRecipesSuccess = (data) => ({
  type: GET_MY_RECIPES.SUCCESS,
  payload: { data },
});

export const getMyRecipesFailure = (error) => ({
  type: GET_MY_RECIPES.FAILURE,
  payload: error,
});

export const getPublicRecipesRequest = () => ({
  type: GET_PUBLIC_RECIPES.REQUEST,
});

export const getPublicRecipesSuccess = (data) => ({
  type: GET_PUBLIC_RECIPES.SUCCESS,
  payload: { data },
});

export const getPublicRecipesFailure = (error) => ({
  type: GET_PUBLIC_RECIPES.FAILURE,
  payload: error,
});

export const duplicateRecipeRequest = (recipeId) => ({
  type: DUPLICATE_RECIPE.REQUEST,
  payload: recipeId,
});

export const duplicateRecipeSuccess = (data) => ({
  type: DUPLICATE_RECIPE.SUCCESS,
  payload: { data },
});

export const duplicateRecipeFailure = (error) => ({
  type: DUPLICATE_RECIPE.FAILURE,
  payload: error,
});

export const publishRecipeRequest = (recipeId, isPublic) => ({
  type: PUBLISH_RECIPE.REQUEST,
  payload: { recipeId, isPublic },
});

export const publishRecipeSuccess = (data) => ({
  type: PUBLISH_RECIPE.SUCCESS,
  payload: { data },
});

export const publishRecipeFailure = (error) => ({
  type: PUBLISH_RECIPE.FAILURE,
  payload: error,
});

export const setRecipeView = (view) => ({
  type: SET_RECIPE_VIEW,
  payload: view,
});

export const resetRecipesState = () => ({
  type: RESET_RECIPES_STATE,
});

export const clearRecipeMessages = () => ({
  type: CLEAR_RECIPE_MESSAGES,
});

// Like Recipe
export const likeRecipeRequest = (recipeId) => ({
  type: LIKE_RECIPE.REQUEST,
  payload: recipeId,
});

export const likeRecipeSuccess = (data) => ({
  type: LIKE_RECIPE.SUCCESS,
  payload: { data },
});

export const likeRecipeFailure = (error) => ({
  type: LIKE_RECIPE.FAILURE,
  payload: error,
});

// Share Recipe
export const shareRecipeRequest = (recipeId) => ({
  type: SHARE_RECIPE.REQUEST,
  payload: recipeId,
});

export const shareRecipeSuccess = (data) => ({
  type: SHARE_RECIPE.SUCCESS,
  payload: { data },
});

export const shareRecipeFailure = (error) => ({
  type: SHARE_RECIPE.FAILURE,
  payload: error,
});

// Search Public Recipes
export const searchPublicRecipesRequest = (filters) => ({
  type: SEARCH_PUBLIC_RECIPES.REQUEST,
  payload: filters,
});

export const searchPublicRecipesSuccess = (data) => ({
  type: SEARCH_PUBLIC_RECIPES.SUCCESS,
  payload: { data },
});

export const searchPublicRecipesFailure = (error) => ({
  type: SEARCH_PUBLIC_RECIPES.FAILURE,
  payload: error,
});

// Set Filters
export const setRecipeFilters = (filters) => ({
  type: SET_RECIPE_FILTERS,
  payload: filters,
});
